<app-site-header></app-site-header>
<app-spinner></app-spinner>

<div class="body_container_outer">
    <div class="page_title_container">
        <h2>Insurance Lookup | <span>Search Insurance</span></h2>

        <img (click)="back()" class="back_btn" src="../../assets/images/back.png"/>
    </div>

    <div class="body_container_inner">
        <div class="Offset_container">
            <div class="pre_auth_container">
                <form [formGroup]="preAuthForm">
                    <h1 class="title">Submit Pre-Authorization Request</h1>


                    <section class="patient_details_section">
                        <div class="row">
                            <!-- <div class="col-sm-3">
                            <div class="input_wrapper">
                                <label class="label">Patient Name</label>
                                <input type="text" placeholder="Patient Name" />
                            </div>
                        </div>
    
                        <div class="col-md-3">
                            <div class="input_wrapper">
                                <label class="label">Patient DOB</label>
                                <input type="date" placeholder="Patient DOB" />
                            </div>
                        </div>
                        
                        <div class="col-md-3">
                            <div class="input_wrapper">
                                <label class="label">Gender</label>
                                <select>
                                    <option value="">Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                </select>
                            </div>
                        </div>
    
                        <div class="col-md-3">
                            <div class="input_wrapper">
                                <label class="label">Patient Mobile No.</label>
                                <input type="number" placeholder="Patient Mobile No." />
                            </div>
                        </div>
    
                        <div class="col-md-3">
                            <div class="input_wrapper">
                                <label class="label">Patient Aadhaar No.</label>
                                <input type="number" placeholder="Patient Aadhaar No." />
                            </div>
                        </div> -->

                            <div class="col-md-3">
                                <div class="input_wrapper">
                                    <label class="label">Admission Date</label>
                                    <input type="date" placeholder="Bill Start Date" formControlName="billStartDate" />
                                    <span class="error_text">{{getErrorMessage('billStartDate' , preAuthForm ,
                                        'Admission Date' , submitted )}}</span>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="input_wrapper">
                                    <label class="label">Discharge Date</label>
                                    <input type="date" placeholder="Bill End Date" formControlName="billEndDate" />
                                    <span class="error_text">{{getErrorMessage('billEndDate' , preAuthForm , 'Discharge
                                        Date' , submitted )}}</span>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="input_wrapper">
                                    <label class="label">Doctor</label>
                                    <select formControlName="doctorId">
                                        <option value="">Select Doctor</option>
                                        <option *ngFor="let doctor of doctorDropdownList" [value]="doctor._id">
                                            {{doctor?.fullname}}</option>
                                    </select>
                                    <div class="error_text">{{getErrorMessage('doctorId' , preAuthForm ,
                                        'Doctor' , submitted )}}</div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="input_wrapper">
                                    <label class="label">Hospital</label>
                                    <select formControlName="hospitalId">
                                        <option value="">Select Doctor</option>
                                        <option *ngFor="let hospital of hospitalDropdownList" [value]="hospital._id">
                                            {{hospital?.hospitalName}}</option>
                                    </select>
                                    <div class="error_text">{{getErrorMessage('hospitalId' , preAuthForm ,
                                        'Hospital' , submitted )}}</div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <section class="patient_items_section">
                        <h2 class="title2">Patient Items List</h2>
                        <div class="table_wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th width="55">Sl no</th>
                                        <th>Item Code</th>
                                        <th>Item Name</th>
                                        <th>Service Date</th>
                                        <th>Quantity</th>
                                        <th>Unit</th>
                                        <th>Unit Price</th>
                                        <th width="140">Net Price</th>
                                        <th width="50"></th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <ng-container formArrayName="items">

                                        <tr *ngFor="let item of items.controls; let i=index" [formGroupName]="i">
                                            <td>{{i + 1}}</td>
                                            <td>
                                                <input placeholder="Item Code" formControlName="itemCode" />
                                                <div class="error_text">{{ getErrorMessage('itemCode', item , 'Item
                                                    Code' , preAuthSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input placeholder="Item Name" formControlName="itemName" />
                                                <div class="error_text">{{ getErrorMessage('itemName', item , 'Item
                                                    Name' , preAuthSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input type="date" formControlName="serviceDate" />
                                                <div class="error_text">{{ getErrorMessage('serviceDate', item ,
                                                    'Service Date' , preAuthSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input type="number" placeholder="Quantity"
                                                    formControlName="quantityValue" />
                                                <div class="error_text">{{ getErrorMessage('quantityValue', item ,
                                                    'Qunatity' , preAuthSubmitted) }}</div>
                                            </td>
                                            <td>
                                                    <select id="quantityUnit" formControlName="quantityUnit">
                                                        <option value="">Select Unit</option>
                                                        <option *ngFor="let unit of quantityUnits" [value]="unit">{{ unit }}</option>
                                                      </select>
                                                      <div class="error_text">{{ getErrorMessage('quantityUnit', item , 'Unit'
                                                        , preAuthSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input  type="number" placeholder="Unit Price" formControlName="unitPrice" />
                                                <div class="error_text">{{ getErrorMessage('unitPrice', item , 'Unit
                                                    Price' , preAuthSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input [readonly]="true" placeholder="Net Price" formControlName="netPrice" />
                                                <div class="error_text">{{ getErrorMessage('netPrice', item , 'Net
                                                    Price' , preAuthSubmitted) }}</div>
                                            </td>
                                            <td><img *ngIf="i == items.length - 1" (click)="addItem()"
                                                    src="../../assets/images/plus.svg" /> <img (click)="removeItem(i)"
                                                    *ngIf="i != items.length - 1" src="../../assets/images/minus.svg" />
                                            </td>
                                        </tr>
                                    </ng-container>

                                    <tr>
                                        <td style="text-align: right;" colspan="7" class="total_td">Total Amount</td>
                                        <td style=" background: rgba(249, 249, 253, 1);  border: 1px solid rgba(199, 216, 255, 1);"
                                            class="total_td">{{preAuthForm.value.totalAmount}}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                    </section>


                    <section class="patient_items_section">
                        <h2 class="title2">Dosage Instructions</h2>

                        <div class="table_wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th width="55">Sl no</th>
                                        <th>Dosage</th>
                                        <th>Additional Instructions Code</th>
                                        <th>Additional Instructions</th>
                                        <th>Frequency</th>
                                        <th>Duration</th>
                                        <th>Duration Unit</th>
                                        <th>Route Code</th>
                                        <th>Route of Administration</th>
                                        <th>Method Code</th>
                                        <th>Method of Administration</th>
                                        <th width="50"></th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <ng-container formArrayName="dosageInstructions">

                                        <tr *ngFor="let item of dosageInstructions.controls; let i=index"
                                            [formGroupName]="i">
                                            <td>{{i + 1}}</td>
                                            <td>
                                                <input placeholder="Dosage"
                                                    formControlName="dosage" />
                                                <div class="error_text">{{ getErrorMessage('dosage', item
                                                    , 'Dosage' , dosageSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input placeholder="Additional Instructions Code"
                                                    formControlName="additionalInstructionCode" />
                                                <marquee class="error_text">{{ getErrorMessage('additionalInstructionCode', item
                                                    , 'Additional Instructions Code' , dosageSubmitted) }}</marquee>
                                            </td>
                                            <td>
                                                <input placeholder="Additional Instructions"
                                                    formControlName="additionalInstruction" />
                                                <marquee class="error_text">{{ getErrorMessage('additionalInstruction', item
                                                    , 'Additional Instructions' , dosageSubmitted) }}</marquee>
                                            </td>
                                            <td>
                                                <select formControlName="timingFrequency">
                                                    <option value="">Select Frequency</option>
                                                    <option value="Once daily">Once daily</option>
                                                    <option value="Twice daily">Twice daily</option>
                                                    <option value="Twice daily">Twice daily</option>
                                                    <option value="Three times daily">Three times daily</option>
                                                    <option value="Four times daily">Four times daily</option>
                                                    <option value="Every 6 hours">Every 6 hours</option>
                                                    <option value="Every 8 hours">Every 8 hours</option>
                                                </select>
                                                <div class="error_text">{{ getErrorMessage('timingFrequency', item ,
                                                    'Frequency' , dosageSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input type="date" placeholder="Duration" formControlName="timingPeriod"
                                                    type="number" />
                                                <div class="error_text">{{ getErrorMessage('timingPeriod', item ,
                                                    'Duration' , dosageSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <select formControlName="periodUnit">
                                                    <option value="">Select Duration Unit</option>
                                                    <option value="Hours">Hours</option>
                                                    <option value="Days">Days</option>
                                                    <option value="Weeks">Weeks</option>
                                                    <option value="Months">Months</option>
                                                </select>
                                                <div class="error_text">{{ getErrorMessage('periodUnit', item ,
                                                    'Duration Unit' , dosageSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Route Code" formControlName="routeCode"
                                                    />
                                                <div class="error_text">{{ getErrorMessage('routeCode', item ,
                                                    'Route Code' , dosageSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <select formControlName="route">
                                                    <option value="">Select Route</option>
                                                    <option value="Oral">Oral</option>
                                                    <option value="Intravenous">Intravenous</option>
                                                    <option value="Intramuscular">Intramuscular</option>
                                                    <option value="Subcutaneous">Subcutaneous</option>
                                                    <option value="Inhalation">Inhalation</option>
                                                    <option value="Topical">Topical</option>
                                                </select>
                                                <div class="error_text">{{ getErrorMessage('route', item , ' Route' ,
                                                    dosageSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Method Code" formControlName="methodCode"
                                                   />
                                                <div class="error_text">{{ getErrorMessage('methodCode', item ,
                                                    'Method Code' , dosageSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <select formControlName="method">
                                                    <option value="">Select Method</option>
                                                    <option value="Injection">Injection</option>
                                                    <option value="Infusion">Infusion</option>
                                                    <option value="Tablet">Tablet</option>
                                                    <option value="Capsule">Capsule</option>
                                                    <option value="Inhaler">Inhaler</option>
                                                    <option value="Patch">Patch</option>
                                                    <option value="Cream">Cream</option>
                                                </select>
                                                <div class="error_text">{{ getErrorMessage('method', item , 'Method' ,
                                                    dosageSubmitted) }}</div>
                                            </td>
                                            <td><img *ngIf="i == items.length - 1" (click)="addDosage()"
                                                    src="../../assets/images/plus.svg" /> <img (click)="removeDosage(i)"
                                                    *ngIf="i != items.length - 1" src="../../assets/images/minus.svg" />
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </section>



                    <section class="patient_items_section">
                        <h2 class="title2">Diagnosis</h2>

                        <div class="table_wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th width="55">Sl no</th>
                                        <th width="250">Diagnosis Code</th>
                                        <th>Diagnosis Description</th>
                                        <th>Diagnosis Codeable Concept Code</th>
                                        <th>Diagnosis Codeable Concept Display</th>
                                        <th width="50"></th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <ng-container formArrayName="diagnosis">

                                        <tr *ngFor="let item of diagnosis.controls; let i=index"
                                            [formGroupName]="i">
                                            <td>{{i + 1}}</td>
                                            <td>
                                                <input placeholder="Diagnosis Code"
                                                    formControlName="diagnosisCode" />
                                                <div class="error_text">{{ getErrorMessage('diagnosisCode', item
                                                    , 'Diagnosis Code' , diagnosisSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <textarea  formControlName="diagnosis" ></textarea>
                                                <div class="error_text">{{ getErrorMessage('diagnosis', item ,
                                                    'Diagnosis Description' , diagnosisSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input  formControlName="diagnosisCodeableConceptCode" placeholder="Diagnosis Codeable Concept Code"/>
                                                <div class="error_text">{{ getErrorMessage('diagnosisCodeableConceptCode', item ,
                                                    'Diagnosis Codeable Concept Code' , diagnosisSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input  formControlName="diagnosisCodeableConceptDisplay" placeholder="Diagnosis Codeable Concept Display"/>
                                                <div class="error_text">{{ getErrorMessage('diagnosisCodeableConceptDisplay', item ,
                                                    'Diagnosis Codeable Concept Display' , diagnosisSubmitted) }}</div>
                                            </td>
                                            <td><img *ngIf="i == items.length - 1" (click)="addDiagnosis()"
                                                    src="../../assets/images/plus.svg" /> <img (click)="removeDiagnosis(i)"
                                                    *ngIf="i != items.length - 1" src="../../assets/images/minus.svg" />
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>




                    </section>


                    <section class="patient_items_section">
                        <h2 class="title2">Procedures Performed</h2>

                        <div class="table_wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th width="55">Sl no</th>
                                        <th width="250">Procedure Code</th>
                                        <th>Procedure Description</th>
                                        <th width="50"></th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <ng-container formArrayName="procedure">

                                        <tr *ngFor="let item of procedure.controls; let i=index"
                                            [formGroupName]="i">
                                            <td>{{i + 1}}</td>
                                            <td>
                                                <input placeholder="Procedure Code"
                                                    formControlName="procedureCode" />
                                                <div class="error_text">{{ getErrorMessage('procedureCode', item
                                                    , 'Procedure Code' , procedureSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <textarea  formControlName="procedure" ></textarea>
                                                <div class="error_text">{{ getErrorMessage('procedure', item ,
                                                    'Procedure Description' , procedureSubmitted) }}</div>
                                            </td>
                                            <td><img *ngIf="i == items.length - 1" (click)="addProcedure()"
                                                    src="../../assets/images/plus.svg" /> <img (click)="removeProcedure(i)"
                                                    *ngIf="i != items.length - 1" src="../../assets/images/minus.svg" />
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>




                    </section>

                    <section class="patient_items_section">
                        <h2 class="title2">Care Team</h2>

                        <div class="table_wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th width="55">Sl no</th>
                                        <th width="250">Role Code</th>
                                        <th>Role Display</th>
                                        <th>Qualification Code</th>
                                        <th>Qualification Display</th>
                                        <th width="50"></th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <ng-container formArrayName="careTeam">

                                        <tr *ngFor="let item of careTeam.controls; let i=index"
                                            [formGroupName]="i">
                                            <td>{{i + 1}}</td>
                                            <td>
                                                <input placeholder="Role Code"
                                                    formControlName="roleCode" />
                                                <div class="error_text">{{ getErrorMessage('roleCode', item
                                                    , 'Role Code' , careTeamSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input placeholder="Role Display"  formControlName="roleDisplay"/>
                                                <div class="error_text">{{ getErrorMessage('roleDisplay', item ,
                                                    'Role Display' , careTeamSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input placeholder="Qualification Code"  formControlName="qualificationCode"/>
                                                <div class="error_text">{{ getErrorMessage('qualificationCode', item ,
                                                    'Qualification Code' , careTeamSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <input placeholder="Qualification Display"  formControlName="qualificationDisplay"/>
                                                <div class="error_text">{{ getErrorMessage('qualificationDisplay', item ,
                                                    'Qualification Display' , careTeamSubmitted) }}</div>
                                            </td>
                                            <td><img *ngIf="i == items.length - 1" (click)="addCareTeam()"
                                                    src="../../assets/images/plus.svg" /> <img (click)="removeCareTeam(i)"
                                                    *ngIf="i != items.length - 1" src="../../assets/images/minus.svg" />
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>




                    </section>


                    <section class="patient_items_section">
                        <h2 class="title2">Supporting Info</h2>

                        <div class="table_wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th width="55">Sl no</th>
                                        <th width="250">Document Type</th>
                                        <th>Treatment Description</th>
                                        <th width="50"></th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <ng-container formArrayName="supportingInfo">

                                        <tr *ngFor="let item of supportingInfo.controls; let i=index"
                                            [formGroupName]="i">
                                            <td>{{i + 1}}</td>
                                            <td>
                                                <input  type="file" (change)="onFileChange($event , i)"
                                                    formControlName="documentName" />
                                                <div class="error_text">{{ getErrorMessage('documentName', item
                                                    , 'Document' , supportingInfoSubmitted) }}</div>
                                            </td>
                                            <td>
                                                <textarea  formControlName="treatment" ></textarea>
                                                <div class="error_text">{{ getErrorMessage('treatment', item ,
                                                    'Treatment Description' , supportingInfoSubmitted) }}</div>
                                            </td>
                                            <td><img *ngIf="i == items.length - 1" (click)="addSupporting()"
                                                    src="../../assets/images/plus.svg" /> <img (click)="removeSuportingInfo(i)"
                                                    *ngIf="i != items.length - 1" src="../../assets/images/minus.svg" />
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>




                    </section>


                    <div class="bottom_btn_container">
                        <button class="login_btn ripple" (click)="submitPreAuth()">SUBMIT</button>
                    </div>

                </form>
            </div>
        </div>
    </div>
</div>










<div class="modal fade" #preAuthSubmittedModal id="preAuthSubmittedModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="check_eligibility_modal modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
      <div class="modal-content" >
        <div class="modal-header">
            <div >
                <div class="success_header">
                    <img src="../../assets/images/success.svg"/>
                    <div class="modal_title">Pre-Authorization Request Sent Successfully</div>
                </div>
            </div>
          <!-- <button  (click)="onCloseEligibilityModal()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
        </div>
        <div class="modal-body" >
            
            <ul class="register_list" >
                <li>The pre-authorization request has been successfully sent, and you can expect to receive a comprehensive response containing all the necessary information shortly. In the meantime, you can track the status of your request at the Pre-Authorization Request Tracker.</li>
               </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary"  >Back</button>
          <button  type="button" class="btn btn-primary" (click)="track()">Track</button>
        </div>
      </div>
    </div>
</div>



